/* eslint-disable react/no-unescaped-entities */
import React from 'react';

const Team = () => {
  return (
    <main id="main">
      <section className="d-flex align-items-center"></section>
      <section id="team" className="team section-bg">
        <div className="container">
          <div className="section-title">
            <span>Team</span>
            <h2>Team</h2>
            <p>Our team members are always here for your questions</p>
          </div>

          <div className="row">
            <div className="col-lg-6 col-md-6 d-flex align-items-stretch">
              <div className="member">
                <img src="assets/img/team/Nikola Jovanovski.jpg" alt="" />
                <h4>Nikola Jovanovski</h4>
                <span>Co-Founder</span>
                <p>
                  MSc. Nikola Jovanovski is a research and teaching assistant at
                  the Faculty of Electrical Engineering and Information
                  technologies (FEEIT Institute of Electronics), Ss. Cyril and
                  Methodius University in Skopje. Jovanovski earned a bachelor
                  of science in informatics and computer engineering in 2014 and
                  a master's degree in embedded systems in 2016 from the Faculty
                  of Electrical Engineering and Information technologies.
                  Currently, Jovanovski is a Ph.D. student and his work focuses
                  on embedded systems design and implementation, especially in
                  the development of advanced control algorithms for CNC
                  machines control and 3D printers. His achievements have been
                  reported in many international conference publications and
                  journals. He has worked on more than forty projects (six
                  supported by the FITD), designed or contribute to the design
                  of 30 commercial systems, and completely made nine JLAB brand
                  products.
                </p>
                <div className="social">
                  <a
                    href="https://www.facebook.com/nikola.jovanovski.12/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="bi bi-facebook"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/jovanovskinik/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="bi bi-instagram"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/in/nikola-jovanovski-a98a3b158/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="bi bi-linkedin"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 d-flex align-items-stretch">
              <div className="member">
                <img src="assets/img/team/Petre Jovanovski.jpg" alt="" />
                <h4>Petre Jovanovski</h4>
                <span>Co-Founder and CEO</span>
                <p>
                  BSc. Petre Jovanovski is a highly skilled mechanical engineer
                  with a broad range of experience in product design and
                  development. He graduated from the University "St. Kliment
                  Ohridski-Technical Faculty-Bitola with a bachelor's degree in
                  mechanical engineering in 2013, and has since worked for
                  various companies as well as a freelancer. With a focus on the
                  design and construction of CNC machines, blow and injection
                  molds for plastic, industrial product design, prototyping, and
                  CNC machining and 3D printing, Petre has gained extensive
                  knowledge and skills in these areas. He has been involved in
                  more than 30 projects for product development, and is
                  responsible for designing all of the JLAB products. Petre is a
                  valuable member of our team, and we are proud to have him
                  contribute his expertise to our organization.
                </p>
                <div className="social">
                  <a href="https://www.facebook.com/pjovanovski">
                    <i className="bi bi-facebook"></i>
                  </a>

                  <a href="https://www.linkedin.com/in/jovanovskipece/">
                    <i className="bi bi-linkedin"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Team;
